import React from 'react';
import { Upload, Crown, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import { isCreator } from '../../utils/roleUtils';

const MyVideosSection = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const userIsCreator = isCreator(userProfile?.role);

  if (!userIsCreator) {
    // Affichage pour les spectateurs
    return (
      <div className="space-y-8">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold text-white">Mes Vidéos</h2>
        </div>

        <div className="text-center py-16 bg-gray-800/30 rounded-xl border border-gray-700">
          <Crown className="h-16 w-16 text-yellow-500 mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-white mb-2">Devenez Créateur</h3>
          <p className="text-gray-400 mb-6">
            Pour uploader et gérer vos vidéos, vous devez avoir le statut de créateur.
          </p>
          <div className="space-y-4">
            <Button
              onClick={() => {
                // Scroll vers le haut et changer d'onglet
                window.scrollTo({ top: 0, behavior: 'smooth' });
                const presentationTab = document.querySelector('[data-tab="presentation"]');
                if (presentationTab) presentationTab.click();
              }}
              className="bg-yellow-600 hover:bg-yellow-700 text-white"
            >
              <Crown className="h-4 w-4 mr-2" />
              Devenir Créateur
            </Button>
            <p className="text-xs text-gray-500">
              Rendez-vous dans la section "Présentation" pour changer votre statut
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Affichage pour les créateurs - redirection vers la page complète
  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-white">Mes Créations IA</h2>
        <Button
          onClick={() => navigate('/add')}
          className="flex items-center space-x-2 bg-pink-600 hover:bg-pink-700"
        >
          <Upload className="h-4 w-4" />
          <span>Nouveau contenu</span>
        </Button>
      </div>

      {/* Aperçu et redirection vers la page complète */}
      <div className="bg-gradient-to-r from-pink-900/20 to-purple-900/20 border border-pink-500/20 rounded-xl p-8 text-center">
        <div className="space-y-4">
          <div className="flex items-center justify-center space-x-2 text-pink-400">
            <Upload className="h-8 w-8" />
            <span className="text-2xl font-bold">Studio Créateur IA</span>
          </div>
          
          <h3 className="text-xl font-semibold text-white">Gérez tous vos contenus IA</h3>
          
          <div className="grid md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto">
            <div className="space-y-2">
              <h4 className="font-medium text-pink-300">✨ Types de contenus :</h4>
              <p className="text-gray-400 text-sm">Films, Séries, Anime, Manga</p>
            </div>
            
            <div className="space-y-2">
              <h4 className="font-medium text-pink-300">🎨 Modèles IA supportés :</h4>
              <p className="text-gray-400 text-sm">Midjourney, DALL-E, Sora, Runway...</p>
            </div>
            
            <div className="space-y-2">
              <h4 className="font-medium text-pink-300">📺 Gestion complète :</h4>
              <p className="text-gray-400 text-sm">Séries, saisons, épisodes</p>
            </div>
            
            <div className="space-y-2">
              <h4 className="font-medium text-pink-300">🖼️ Images haute qualité :</h4>
              <p className="text-gray-400 text-sm">Miniatures et bannières</p>
            </div>
          </div>

          <div className="pt-4">
            <Button
              onClick={() => navigate('/my-videos')}
              className="bg-pink-600 hover:bg-pink-700 text-white"
              size="lg"
            >
              <span>Accéder au studio complet</span>
              <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
            
            <p className="text-xs text-gray-500 mt-2">
              Page dédiée avec toutes vos créations et outils avancés
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyVideosSection;